module.exports = "<sui-select \n  class=\"selection\"\n  placeholder=\"Est...\"\n  [ngModel]=\"active\"\n  (ngModelChange)=\"onChange($event)\"\n  [options]=\"options\"\n  [isSearchable]=\"true\"\n  labelField=\"label\"\n  valueField=\"value\"\n  #searchSelect>\n  <sui-select-option \n      *ngFor=\"let o of searchSelect.filteredOptions\" \n      [value]=\"o\">\n    </sui-select-option>\n</sui-select>\n";


//////////////////
// WEBPACK FOOTER
// ./app/components/select-relationship/select-relationship.component.html
// module id = 1023
// module chunks = 0